
<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img class="Form__thank_img" src="assets/img/unsubscribe.png" alt="ok">
          <p class="Form__tx">
            お客様のメールアドレスへのメール送信が複数回エラーとなりました。<br>このままの状態だと重要なお知らせメールなどの受信が出来ませんので、<br class="_dsp-none--sp">下のボタンよりメールアドレスをご確認ください。
          </p>
          <a href="change/mail" class="Btn__blue Btn__blue--lg Form__btn--mt_md Form__btn--mt_sp_sm">確認・変更はこちらから</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MailAddress'
}
</script>
